module.exports = __webpack_public_path__ + "img/circle-waveform-lines.d52d2de8.svg";